module.exports = __webpack_public_path__ + "assets/img/img46.6b12b9ae.png";